<template>
  <div class="relative flex h-full">
    <component :is="currentToolbar" v-if="!hideNavigation" />

    <!-- Content area -->
    <div id="content-area" class="flex flex-1 flex-col overflow-hidden">
      <!-- Main content -->
      <div class="flex flex-1 items-stretch overflow-hidden">
        <main class="flex-1 overflow-y-auto">
          <slot></slot>
        </main>
      </div>
    </div>

    <InactivityOverlay v-if="!isEmbedded" />
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'
import MainToolbar from '@/components/MainToolbar.vue'
import MainToolbarLanding from '@/components/MainToolbarLanding.vue'
import MainToolbarEmbed from '@/components/MainToolbarEmbed.vue'
import { useEmbedMode } from '@/hooks/use-embed-mode'

const InactivityOverlay = defineAsyncComponent(() => import('@/components/InactivityOverlay.vue'))

const route = useRoute()
const { isEmbedded } = useEmbedMode()

const hideNavigation = computed(() => {
  return ['Scenario Slide Pack'].includes(route.name)
})

const currentToolbar = computed(() => {
  const landingPages = ['Landing', 'Settings', 'InviteAccessUsers', 'No Boards', 'Super Admin']

  if (isEmbedded.value) {
    if (!landingPages.includes(route.name) && route.name !== 'Plan View') {
      return MainToolbarEmbed
    }

    return null
  }

  return landingPages.includes(route.name)
    ? MainToolbarLanding
    : route.name !== 'Plan View'
      ? MainToolbar
      : null
})

defineExpose({
  name: 'AppLayout'
})
</script>
